import React from "react";
import "../../Styles/Cart.css";
import Page from "../../Containers/Page/Page";
import { useState } from "react";
import MobileNavBar from "../../Components/Navs/MobileNavBar";
import { useLocation, useNavigate } from "react-router";
import { useEffect } from "react";
import {
  Transaction_Card,
  Transaction_Profile,
  Transaction_Payment,
} from "../../Connections/Transaction";
import Toast from "../../Utils/Toast";
import Rechargewallet from "../Profile/Rechargewallet";
import ModalCart from "../../Components/Alerts/ModalCart";
import RechargewalletCart from "../Profile/RechargewalletCart";

const Cart = () => {
  const navigator = useNavigate();
  const loc = useLocation();
  const location = useLocation();

  //==============================================

  const [offerCode, setOfferCode] = useState();
  const [showPayment, setShowPayment] = useState(false);
  const [cartInfo, setCartInfo] = useState({});
  const [User, setUser] = useState({});
  const [Discount, setDiscount] = useState({});
  const [PeymentType, setPeymentType] = useState();
  const [collection, setCollection] = useState();
  const [alert, setAlert] = useState();
  const [rechargewalletModal, setRechargewalletModal] = useState(false);

  //==============================================

  const getCartItem = () => {
    Transaction_Card.Getcart()
      .then((res) => {
        if (res[0]) setCartInfo(res[2].data);
        console.log(res[2].data);
      })
      .catch((err) => console.log(err));
  };

  const removeCartItem = (id) => {
    Transaction_Card.DeleteCart(id)
      .then((res) => {
        if (res[0]) {
          setCartInfo(res[2].data || null);
          Toast("success", "کتاب با موفقیت حذف شد!");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const checkdiscountCode = () => {
    Transaction_Payment.CheckDiscountCode(offerCode).then((res) => {
      if (res[0]) setDiscount(res[2].data);
      else Toast("error", res[1]);
    });
  };

  const payPrice = () => {
    const domainname = window.location.hostname;
    const protocol = window.location.protocol;
    let url;
    if (loc?.state?.BookID) {
      url =
        `${protocol}//${domainname}/book/SE` +
        loc.state.BookID +
        "/" +
        loc.state.bookName;
    } else {
      url = `${protocol}//${domainname}/hisstori/home`;
    }
    console.log(PeymentType);
    const Formdata = new FormData();
    if (Object.keys(Discount).length > 0) {
      Formdata.append("DiscountCode", offerCode);
    }
    Formdata.append("Url", url);
    Formdata.append("PaymentType", PeymentType);

    Transaction_Payment.PaymentRequest(Formdata).then((res) => {
      if (res[0]) {
        if (!res[2].data.isFinishPayment) {
          window.location.href = res[2].data.url;
        } else {
          Toast("success", "پرداخت از کیف پول انجام شد");
          navigator(-1);
          ModalCart(
            <ModalCart
              image={"/imgs/cart/Asset.svg"}
              title={"خریدت با موفقیت انجام شد."}
              btnText={"برگشت به کتابنو"}
            >
              <div className="ModalCart">
                <input
                  className="ModalCart-input"
                  id="Code"
                  autoComplete={false}
                  required
                  type="text"
                />
                <label htmlFor="Code" className="ModalCart-label">
                  کد رهگیری
                </label>
                <button className="ModalCart-button">تایید کد</button>
              </div>
            </ModalCart>
          );
        }
      } else {
        Toast("error", res[1]);
        ModalCart(
          <ModalCart
            image={"/imgs/cart/AssetError.svg"}
            title={"خریدت ناموفق بود!"}
            btnText={"برگشت به کتابنو"}
          />
        );
      }
    });
  };

  const deleteAllItemInCart = () => {
    Transaction_Card.DeleteAll()
      .then((res) => {
        if (res[0]) {
          setCartInfo([]);
          Toast("success", "سبد خرید با موفقیت خالی شد!");
        }
      })
      .catch((err) => console.log(err));
  };
  console.log("current Pathname ", window.location.pathname);
  //==============================================

  useEffect(() => {
    getCartItem();
    Transaction_Profile.GetProfile().then((res) => {
      if (res[0]) setUser(res[2].data);
    });
  }, []);

  //==============================================
  const handelCart = () => {
    navigator(-1);
  };
  //==============================================

  const dataLayer = window.dataLayer;

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const Authority = urlParams.get("Authority");
    const Status = urlParams.get("Status");
    if (Authority != null && Status != "Ok") {
      Transaction_Payment.VerifyPayment(Authority).then((res) => {
        if (res[0]) {
          Toast("success", "خرید با موفقیت انجام شد");
          Transaction_Payment.GetLastCharge()
            .then((res) => {
              if (res[0]) {
                let chargeLayerValue = {
                  price: res[2]?.data?.price,
                  refId: res[2]?.data?.refId,
                };
                dataLayer.push(chargeLayerValue);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          Toast("error", "خرید شما ناموفق بوده است");
        }
        Transaction_Profile.GetProfile().then((res) => {
          if (res[0]) setUser(res[2].data);
        });
      });
    }
  }, []);

  return (
    <div className="cart-page">
      <Page>
        <MobileNavBar
          text={"سبد خرید"}
          // action={() => {
          //     rechargewalletModal
          //         ? setRechargewalletModal(false)
          //         :navigator(location?.state.prevPath);
          //         // : navigator("/hisstori/home");
          // }}
          action={() => handelCart()}
        />
        <div className="blog-back-icon" onClick={() => handelCart()}>
          <svg
            width="8"
            height="15"
            viewBox="0 0 8 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.16984 15C1.31923 15.0005 1.46684 14.9675 1.60182 14.9035C1.7368 14.8395 1.85572 14.746 1.94984 14.63L6.77984 8.63C6.92692 8.45107 7.00732 8.22663 7.00732 7.995C7.00732 7.76338 6.92692 7.53893 6.77984 7.36L1.77984 1.36C1.6101 1.15578 1.36619 1.02736 1.10176 1.00298C0.837334 0.978601 0.574053 1.06026 0.369836 1.23C0.16562 1.39974 0.0371957 1.64365 0.012816 1.90808C-0.0115638 2.1725 0.0700977 2.43578 0.239836 2.64L4.70984 8L0.389837 13.36C0.267554 13.5068 0.189877 13.6855 0.165997 13.8751C0.142118 14.0646 0.173034 14.257 0.25509 14.4296C0.337146 14.6021 0.466906 14.7475 0.629016 14.8486C0.791127 14.9497 0.978803 15.0022 1.16984 15Z"
              fill="#ffffff"
            ></path>
          </svg>
        </div>
        {/* action={()=> navigator(location?.state?.prevPath== "/cart" ? `${location?.state?.prevPath}` : `${location?.state?.prevPath}`)} */}
        {rechargewalletModal ? (
          <RechargewalletCart
            walletBalance={User.balance}
            close={() => setRechargewalletModal(false)}
          />
        ) : null}
        <div className="Cart">
          {cartInfo?.books?.length > 0 ? (
            <>
              <div
                className="mobile-hidden"
                style={{ display: "flex", alignItems: "start" }}
              >
                <div className="Cart-right">
                  {cartInfo?.books?.map((item) => (
                    <>
                      <div className="Cart-right-top" key={item.id}>
                        <div className="Cart-right-top-inside">
                          <div className="Cart-right-top-inside-right">
                            <img
                              className="Cart-right-top-inside-right-img"
                              src={item.pic}
                            />
                          </div>
                          <div className="Cart-right-top-inside-center">
                            <div className="Cart-right-top-inside-center-top">
                              <p
                                className="Cart-right-top-inside-center-top-name"
                                style={{
                                  marginRight: "20px",
                                }}
                              >
                                {item.title}
                              </p>

                              <div
                                id="deleteFromCart"
                                onClick={() => removeCartItem(item.id)}
                                className="Cart-right-top-inside-center-top-image delete-cart-btn"
                              >
                                <img
                                  className="Cart-right-top-inside-center-top-image-img"
                                  src="imgs/Cart/delete.svg"
                                />
                              </div>
                            </div>
                            <div className="Cart-right-top-inside-center-top">
                              <p className="Cart-right-top-inside-center-top-name-description">
                                {item.description}
                              </p>
                            </div>
                            <div className="Cart-right-top-inside-center-top">
                              <p
                                className="Cart-right-top-inside-center-top-nameBook"
                                style={{
                                  marginRight: "20px",
                                }}
                              >
                                {item.preTitle}
                              </p>
                            </div>
                            <div className="Cart-right-top-inside-center-bottom">
                              <div className="Cart-right-top-inside-center-bottom-right">
                                <p className="Cart-right-top-inside-center-bottom-right-text1">
                                  تخفیف
                                </p>
                                <span className="Cart-right-top-inside-center-bottom-right-text2 number-font">
                                  {item.discount} تومان
                                </span>
                              </div>
                              <div className="Cart-right-top-inside-center-bottom-left">
                                <p className="Cart-right-top-inside-center-bottom-left-text1">
                                  قیمت نهایی
                                </p>
                                <span className="Cart-right-top-inside-center-bottom-left-text2 number-font">
                                  {item.price} تومان
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ))}
                  <div className="Cart-right-delete-cart">
                    <p
                      id="abandonCart"
                      className="Cart-right-delete-cart-text abandon-cart-btn"
                      onClick={deleteAllItemInCart}
                    >
                      خالی کردن سبد خرید
                    </p>
                  </div>
                </div>
                <div className="Cart-left">
                  <div className="Cart-HelpText-Desktap-Collection">
                    <p>
                      اگر نمیدونید، بدونید که تو کتابنو، شما نسخه الکترونیکی
                      کتابا رو می‌خرید که فقط تو سایت قابل خوندن هستند، نه نسخه
                      چاپی رو!
                    </p>
                  </div>
                  <div className="Cart-left-inside" style={{ paddingTop: 10 }}>
                    <div className="Cart-left-inside-item1">
                      <p className="Cart-left-inside-item1-title">
                        نحوه پرداخت
                      </p>
                      <div className="Cart-left-inside-item1-wallet">
                        <div
                          className="Cart-left-inside-item1-wallet-top"
                          onClick={() => setPeymentType(2)}
                        >
                          <input
                            type="radio"
                            name="answer"
                            id="fourRadioInput"
                            className="Cart-left-inside-item1-wallet-top-input"
                            style={{
                              width: "15px",
                              height: "15px",
                            }}
                            onClick={() => setPeymentType(2)}
                          />
                          <label
                            htmlFor="fourRadioInput"
                            className="Cart-left-inside-item1-wallet-top-text"
                          >
                            کیف پول
                          </label>
                        </div>
                        <div className="Cart-left-inside-item1-wallet-center">
                          <div className="Cart-left-inside-item1-wallet-center-right">
                            <p className="Cart-left-inside-item1-wallet-center-right-text1">
                              موجودی:
                            </p>
                            <span className="Cart-left-inside-item1-wallet-center-right-text2 number-font">
                              {User?.balance} تومان
                            </span>
                          </div>
                          <div className="Cart-left-inside-item1-wallet-center-left">
                            <button
                              onClick={() => setRechargewalletModal(true)}
                              className="Cart-left-inside-item1-wallet-center-left-button"
                            >
                              <img
                                className="Cart-left-inside-item1-wallet-center-left-button-img"
                                src="imgs/Cart/add.svg"
                              />
                              افزایش اعتبار
                            </button>
                          </div>
                        </div>
                        <div
                          className="Cart-left-inside-item1-wallet-bottom"
                          onClick={() => setPeymentType(1)}
                        >
                          <input
                            type="radio"
                            name="answer"
                            id="thirdRadioInput"
                            checked
                            className="Cart-left-inside-item1-wallet-bottom-input"
                            style={{
                              width: "15px",
                              height: "15px",
                            }}
                            onClick={() => setPeymentType(1)}
                          />
                          <label
                            htmlFor="thirdRadioInput"
                            className="Cart-left-inside-item1-wallet-bottom-text"
                          >
                            درگاه پرداخت
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="Cart-left-inside-item2">
                      <p className="Cart-left-inside-item2-title">کد تخفیف</p>
                      <div className="Cart-left-inside-item2-code">
                        <input
                          className="Cart-left-inside-item2-code-input"
                          id="Code"
                          autoComplete={false}
                          required
                          type="text"
                          value={offerCode}
                          onChange={(e) => setOfferCode(e.target.value)}
                        />
                        <img
                          className="Cart-left-inside-item2-code-icon"
                          src="imgs/Cart/delete-code.svg"
                        />
                        <label
                          htmlFor="Code"
                          className="Cart-left-inside-item2-code-label"
                        >
                          کد تخفیف
                        </label>
                        <button
                          className="Cart-left-inside-item2-code-button"
                          onClick={() => checkdiscountCode()}
                          disabled={offerCode == ""}
                        >
                          تایید کد
                        </button>
                      </div>
                      <div className="Cart-left-inside-item2-off">
                        <p className="Cart-left-inside-item2-off-text">
                          مبلغ تخفیف:
                        </p>
                        <span className="Cart-left-inside-item2-Money">
                          {Discount?.discountPrice || 0} تومان
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="Cart-left-inside-item3 d-none">
                    <div className="Cart-left-inside-item3-right">
                      <p className="Cart-left-inside-item3-right-text">
                        دریافتی از این مرحله
                      </p>
                    </div>
                    <div className="Cart-left-inside-item3-center">
                      <img
                        className="Cart-left-inside-item3-img"
                        src="imgs/Cart/Almas.svg"
                      />
                      <p className="Cart-left-inside-item3-text">200 امتیاز</p>
                    </div>
                    <div className="Cart-left-inside-item3-left">
                      <img
                        className="Cart-left-inside-item3-img"
                        src="imgs/Cart/Seke.svg"
                      />
                      <p className="Cart-left-inside-item3-text">10 امتیاز</p>
                    </div>
                  </div>
                  <div className="Cart-left-inside-item4 ">
                    <div className="Cart-left-inside-item4-inside">
                      <div className="Cart-left-inside-item4-inside-right">
                        <button
                          id="goForPay"
                          className="Cart-left-inside-item4-inside-right-button go-pay-btn"
                          onClick={() => payPrice()}
                        >
                          ادامه
                        </button>
                      </div>
                      <div className="Cart-left-inside-item4-inside-left">
                        <p className="Cart-left-inside-item4-inside-left-text">
                          مبلغ قابل پرداخت
                        </p>
                        <span className="Cart-left-inside-item4-inside-left-Money">
                          {Discount.priceWithDiscount
                            ? Discount.priceWithDiscount
                            : cartInfo?.sumPrice}{" "}
                          تومان
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="desktop-hidden-block"
                style={{ paddingBottom: "350px" }}
              >
                {showPayment ? (
                  <div className="Cart-left">
                    <div className="Cart-left-inside">
                      <div className="Cart-left-inside-item1">
                        <p className="Cart-left-inside-item1-title">
                          نحوه پرداخت
                        </p>
                        <div className="Cart-left-inside-item1-wallet">
                          <div
                            className="Cart-left-inside-item1-wallet-top"
                            onClick={() => setPeymentType(2)}
                          >
                            <input
                              type="radio"
                              id="firstRadioInput"
                              name="answer"
                              style={{
                                width: "15px",
                                height: "15px",
                                marginTop: 0,
                              }}
                              className="Cart-left-inside-item1-wallet-top-input"
                            />
                            <label
                              htmlFor="firstRadioInput"
                              className="Cart-left-inside-item1-wallet-top-text"
                            >
                              کیف پول
                            </label>
                          </div>
                          <div className="Cart-left-inside-item1-wallet-center">
                            <div className="Cart-left-inside-item1-wallet-center-right">
                              <p className="Cart-left-inside-item1-wallet-center-right-text1">
                                موجودی:
                              </p>
                              <span className="Cart-left-inside-item1-wallet-center-right-text2 number-font">
                                {User.balance} تومان
                              </span>
                            </div>
                            <div className="Cart-left-inside-item1-wallet-center-left">
                              <button
                                onClick={() => setRechargewalletModal(true)}
                                className="Cart-left-inside-item1-wallet-center-left-button"
                              >
                                <img
                                  className="Cart-left-inside-item1-wallet-center-left-button-img"
                                  src="imgs/Cart/add.svg"
                                />
                                افزایش اعتبار
                              </button>
                            </div>
                          </div>
                          <div
                            className="Cart-left-inside-item1-wallet-bottom"
                            onClick={() => setPeymentType(1)}
                          >
                            <input
                              type="radio"
                              id="secondRadioInput"
                              checked
                              name="answer"
                              style={{
                                width: "15px",
                                height: "15px",
                                marginTop: 0,
                              }}
                              className="Cart-left-inside-item1-wallet-bottom-input"
                            />
                            <label
                              htmlFor="secondRadioInput"
                              className="Cart-left-inside-item1-wallet-bottom-text"
                            >
                              درگاه پرداخت
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="Cart-left-inside-item2">
                        <p className="Cart-left-inside-item2-title">کد تخفیف</p>
                        <div className="Cart-left-inside-item2-code">
                          <input
                            className="Cart-left-inside-item2-code-input"
                            id="Code"
                            required
                            type="text"
                            autoComplete={false}
                            value={offerCode}
                            onChange={(e) => setOfferCode(e.target.value)}
                          />
                          <img
                            className="Cart-left-inside-item2-code-icon"
                            src="imgs/Cart/delete-code.svg"
                          />
                          <label
                            htmlFor="Code"
                            className="Cart-left-inside-item2-code-label"
                          >
                            کد تخفیف
                          </label>
                          <button
                            className="Cart-left-inside-item2-code-button"
                            disabled={offerCode == ""}
                            onClick={() => checkdiscountCode()}
                          >
                            تایید کد
                          </button>
                        </div>
                        <div className="Cart-left-inside-item2-off">
                          <p className="Cart-left-inside-item2-off-text">
                            مبلغ تخفیف:
                          </p>
                          <span className="Cart-left-inside-item2-Money">
                            {Discount?.discountPrice || 0} تومان
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="Cart-left-inside-item3 d-none">
                      <div className="Cart-left-inside-item3-right">
                        <p className="Cart-left-inside-item3-right-text">
                          دریافتی از این مرحله
                        </p>
                      </div>
                      <div className="Cart-left-inside-item3-center">
                        <img
                          className="Cart-left-inside-item3-img"
                          src="imgs/Cart/Almas.svg"
                        />
                        <p className="Cart-left-inside-item3-text">
                          200 امتیاز
                        </p>
                      </div>
                      <div className="Cart-left-inside-item3-left">
                        <img
                          className="Cart-left-inside-item3-img"
                          src="imgs/Cart/Seke.svg"
                        />
                        <p className="Cart-left-inside-item3-text">10 امتیاز</p>
                      </div>
                    </div>
                    <div className="Cart-left-inside-item4 ">
                      <div className="Cart-left-inside-item4-inside">
                        <div className="Cart-left-inside-item4-inside-right">
                          <button className="Cart-left-inside-item4-inside-right-button">
                            ادامه
                          </button>
                        </div>
                        <div className="Cart-left-inside-item4-inside-left">
                          <p className="Cart-left-inside-item4-inside-left-text">
                            مبلغ قابل پرداخت
                          </p>
                          <span className="Cart-left-inside-item4-inside-left-Money">
                            {Discount.priceWithDiscount
                              ? Discount.priceWithDiscount
                              : cartInfo?.sumPrice}{" "}
                            تومان
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="Cart-Collection-position desktop-hidden">
                      <div className="Cart-HelpText-Collection">
                        <p>
                          اگر نمیدونید، بدونید که تو کتابنو، شما نسخه الکترونیکی
                          کتابا رو می‌خرید که فقط تو سایت قابل خوندن هستند، نه
                          نسخه چاپی رو!
                        </p>
                      </div>
                      <div className="Cart-Collection desktop-hidden">
                        <input
                          className="Cart-Collection-input"
                          id="Code"
                          autoComplete={false}
                          required
                          type="text"
                          value={`${
                            Discount.priceWithDiscount
                              ? Discount.priceWithDiscount
                              : cartInfo?.sumPrice
                          } تومان `}
                        />
                        <label htmlFor="Code" className="Cart-Collection-label">
                          مجموع سبد خرید
                        </label>
                      </div>
                    </div>
                    <div
                      className="Cart-next desktop-hidden"
                      style={{ marginTop: "30px" }}
                    >
                      <button
                        id="goForPay"
                        className="Cart-next-button go-pay-btn"
                        onClick={payPrice}
                      >
                        تایید و پرداخت
                      </button>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="Cart-right">
                      {cartInfo?.books?.map((item) => (
                        <div className="Cart-right-top" key={item.id}>
                          <div className="Cart-right-top-inside">
                            <div className="Cart-right-top-inside-right">
                              <img
                                className="Cart-right-top-inside-right-img"
                                src={item.pic}
                              />
                            </div>
                            <div className="Cart-right-top-inside-center">
                              <div className="Cart-right-top-inside-center-top">
                                <p className="Cart-right-top-inside-center-top-name">
                                  {item.title}
                                </p>
                                <div className="Cart-right-top-inside-center-top-image">
                                  <img
                                    id="deleteFromCart"
                                    onClick={() => removeCartItem(item.id)}
                                    className="Cart-right-top-inside-center-top-image-img delete-cart-btn"
                                    src="imgs/Cart/delete.svg"
                                  />
                                </div>
                              </div>
                              <div className="Cart-right-top-inside-center-top">
                                <p className="Cart-right-top-inside-center-top-name-description">
                                  {item.description}
                                </p>
                              </div>
                              <div className="Cart-right-top-inside-center-bottom">
                                <div className="Cart-right-top-inside-center-bottom-right">
                                  <p className="Cart-right-top-inside-center-bottom-right-text1">
                                    تخفیف
                                  </p>
                                  <span className="Cart-right-top-inside-center-bottom-right-text2 number-font">
                                    {item.discount} تومان
                                  </span>
                                </div>
                                <div className="Cart-right-top-inside-center-bottom-left">
                                  <p className="Cart-right-top-inside-center-bottom-left-text1">
                                    قیمت نهایی
                                  </p>
                                  <span className="Cart-right-top-inside-center-bottom-left-text2 number-font">
                                    {item.price} تومان
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="Cart-right-delete-cart">
                      <p
                        id="abandonCart"
                        className="Cart-right-delete-cart-text abandon-cart-btn"
                        style={{ fontSize: "14px" }}
                        onClick={deleteAllItemInCart}
                      >
                        خالی کردن سبد خرید
                      </p>
                    </div>
                    <div className="Cart-Collection-position desktop-hidden">
                      <div className="Cart-HelpText-Collection">
                        <p>
                          اگر نمیدونید، بدونید که تو کتابنو، شما نسخه الکترونیکی
                          کتابا رو می‌خرید که فقط تو سایت قابل خوندن هستند، نه
                          نسخه چاپی رو!
                        </p>
                      </div>
                      <div className="Cart-Collection desktop-hidden">
                        <input
                          className="Cart-Collection-input"
                          id="Code"
                          autoComplete={false}
                          required
                          readOnly
                          type="text"
                          value={`${
                            Discount.priceWithDiscount
                              ? Discount.priceWithDiscount
                              : cartInfo?.sumPrice
                          } تومان`}
                        />
                        <label htmlFor="Code" className="Cart-Collection-label">
                          مجموع سبد خرید
                        </label>
                      </div>
                    </div>

                    <div className="Cart-next desktop-hidden">
                      <button
                        className="Cart-next-button"
                        onClick={() => setShowPayment(!showPayment)}
                      >
                        تایید و ادامه
                      </button>
                    </div>
                  </>
                )}
              </div>
            </>
          ) : (
            <div className="cart-null">
              <p>سبد خریدت فعلا خالیه، زود باش پرش کن:)</p>
            </div>
          )}
        </div>
      </Page>
    </div>
  );
};
export default Cart;
